var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isDisabled
              ? "分集详情"
              : _vm.formData.id
              ? "编辑分集"
              : "新增分集",
            visible: _vm.value,
            "append-to-body": "",
            width: "1200px",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                disabled: _vm.isDisabled,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "background-color": "#f6f6f6",
                    padding: "25px",
                    "border-radius": "10px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c("el-col", { attrs: { span: 11 } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              width: "100px",
                            },
                          },
                          [_vm._v("乐播分集 ID：")]
                        ),
                        _vm._v(
                          "\n            " + _vm._s(_vm.formData.id || "--")
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "分集序号：", prop: "num" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  placeholder: "请输入分集序号",
                                  min: 0,
                                },
                                on: {
                                  input: () => {
                                    if (_vm.formData.num !== "") {
                                      const pattern = /^[1-9]\d*$/
                                      if (!pattern.test(_vm.formData.num)) {
                                        _vm.formData.num = ""
                                      }
                                    }
                                  },
                                },
                                model: {
                                  value: _vm.formData.num,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "num", $$v)
                                  },
                                  expression: "formData.num",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "分集名称：", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入分集名称",
                                  maxlength: 99,
                                },
                                model: {
                                  value: _vm.formData.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "name", $$v)
                                  },
                                  expression: "formData.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "分集描述：", prop: "aword" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入分集描述",
                                  maxlength: 999,
                                },
                                model: {
                                  value: _vm.formData.aword,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "aword", $$v)
                                  },
                                  expression: "formData.aword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "横图：",
                                prop: "horizontalImgLarge",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    width: "330px",
                                  },
                                  attrs: {
                                    action: _vm.actionUrl,
                                    "show-file-list": false,
                                    "on-success": (res) => {
                                      _vm.handleAvatarSuccess(
                                        res,
                                        "horizontalImgLarge"
                                      )
                                    },
                                    "before-upload": _vm.beforeAvatarUpload,
                                  },
                                },
                                [
                                  _vm.formData.horizontalImgLarge
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          src: _vm.formData.horizontalImgLarge,
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "竖图：",
                                prop: "verticalImgLarge",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    "show-file-list": false,
                                    action: _vm.actionUrl,
                                    "on-success": (res) => {
                                      _vm.handleAvatarSuccess(
                                        res,
                                        "verticalImgLarge"
                                      )
                                    },
                                    "before-upload": _vm.beforeAvatarUpload,
                                  },
                                },
                                [
                                  _vm.formData.verticalImgLarge
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: {
                                          src: _vm.formData.verticalImgLarge,
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "时长：", prop: "duration" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  placeholder: "请输入时长",
                                },
                                on: {
                                  input: () => {
                                    if (_vm.formData.duration !== "") {
                                      const pattern = /^[1-9]\d*$/
                                      if (
                                        !pattern.test(_vm.formData.duration)
                                      ) {
                                        _vm.formData.duration = ""
                                      }
                                    }
                                  },
                                },
                                model: {
                                  value: _vm.formData.duration,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "duration", $$v)
                                  },
                                  expression: "formData.duration",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "试看时长：",
                                prop: "trialDuration",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入试看时长" },
                                on: {
                                  input: () => {
                                    if (_vm.formData.trialDuration !== "") {
                                      const pattern = /^[1-9]\d*$/
                                      if (
                                        !pattern.test(
                                          _vm.formData.trialDuration
                                        )
                                      ) {
                                        _vm.formData.trialDuration = ""
                                      }
                                    }
                                  },
                                },
                                model: {
                                  value: _vm.formData.trialDuration,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "trialDuration", $$v)
                                  },
                                  expression: "formData.trialDuration",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "是否解锁：", prop: "feeMode" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.feeMode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "feeMode", $$v)
                                    },
                                    expression: "formData.feeMode",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "视频样式：", prop: "direction" },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.direction,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "direction", $$v)
                                    },
                                    expression: "formData.direction",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("横视频"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("竖视频"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                              ],
                              attrs: { label: "播放介质：", prop: "playUrl" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "flex-start",
                                  },
                                },
                                [
                                  !_vm.isDisabled
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "mini" },
                                          on: { click: _vm.choiceMedium },
                                        },
                                        [_vm._v("选择介质")]
                                      )
                                    : _vm._e(),
                                  _vm.selectedMedium.name
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("totoLowerCase")(
                                              _vm.selectedMedium.name +
                                                "." +
                                                _vm.selectedMedium.fileFormat
                                            )
                                          ) + "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "二维码地址：", prop: "qrCode" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入二维码地址",
                                  maxlength: 999,
                                },
                                model: {
                                  value: _vm.formData.qrCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "qrCode", $$v)
                                  },
                                  expression: "formData.qrCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { margin: "0 0 20px 50px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                              ],
                              attrs: { label: "播放链接：", prop: "playUrl" },
                            },
                            [
                              !_vm.isDisabled
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入播放链接",
                                      maxlength: 999,
                                    },
                                    on: { blur: _vm.analysisDuration },
                                    model: {
                                      value: _vm.formData.playUrl,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "playUrl", $$v)
                                      },
                                      expression: "formData.playUrl",
                                    },
                                  })
                                : _c("div", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.formData.playUrl) +
                                        "\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#2140ef",
                                          cursor: "pointer",
                                          padding: "0 10px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowImage(
                                              _vm.formData.playUrl,
                                              "video"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("预览")]
                                    ),
                                  ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { margin: "0 0 0 50px", padding: "25px 25px 0" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "播放介质：", prop: "status" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "status", $$v)
                                },
                                expression: "formData.status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("上线"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("下线"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 13 } }, [
                    _vm.isDisabled
                      ? _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#2140ef",
                                cursor: "pointer",
                                padding: "0 10px",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.innerVisible = true
                                },
                              },
                            },
                            [_vm._v("三方分集信息")]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isDisabled
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.closeDialog } }, [
                    _vm._v("取 消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.mediaEpisodeSave },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.innerVisible
            ? _c(
                "el-dialog",
                {
                  attrs: {
                    width: "1000px",
                    title: "三方分集信息",
                    visible: _vm.innerVisible,
                    "modal-append-to-body": false,
                    "before-close": (done) => {
                      _vm.innerVisible = false
                      done()
                    },
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.innerVisible = $event
                    },
                  },
                },
                [
                  _vm.formData.episodePartnerData
                    ? _c(
                        "el-row",
                        { staticStyle: { margin: "0 0 20px 50px" } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "130px",
                                },
                              },
                              [_vm._v("三方分集 ID：")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formData.episodePartnerData
                                    ? _vm.formData.episodePartnerData
                                        .partnerEpisodeId || "--"
                                    : "--"
                                )
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "130px",
                                },
                              },
                              [_vm._v("三方分集状态：")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formData.episodePartnerData
                                    ? { 0: "关", 1: "开" }[
                                        _vm.formData.episodePartnerData
                                          .partnerEpisodeStatus
                                      ] || "--"
                                    : "--"
                                )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.episodePartnerData
                    ? _c(
                        "el-row",
                        { staticStyle: { margin: "0 0 20px 50px" } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "130px",
                                },
                              },
                              [_vm._v("版权商分集 ID：")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formData.episodePartnerData
                                    ? _vm.formData.episodePartnerData
                                        .copyrightEpisodeId || "--"
                                    : "--"
                                )
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "130px",
                                },
                              },
                              [_vm._v("版权商分集编号：：")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.formData.episodePartnerData
                                    ? _vm.formData.episodePartnerData
                                        .copyrightEpisodeCode || "--"
                                    : "--"
                                )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("MediumDialog", { ref: "medium", on: { select: _vm.mediumSelect } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }